import { actionTypes } from "./actionTypes";
export const start = (config, file) => ({
    type: actionTypes.IMPORT,
    payload: { config, file }
});
export const setImportPending = payload => ({
    type: actionTypes.IMPORT_PENDING,
    payload
});
export const setImportError = (payload, error) => ({
    type: actionTypes.IMPORT_ERROR,
    payload: Object.assign(Object.assign({}, payload), { error })
});
export const setImportFinish = payload => ({
    type: actionTypes.IMPORT_FINISH,
    payload
});
//# sourceMappingURL=actions.js.map